import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import { IStore } from "./reducers";

type AppDispatchType = ThunkDispatch<any, null, AnyAction>;

const useAppDispatch = () => useDispatch<AppDispatchType>();
const useAppSelector: TypedUseSelectorHook<IStore> = useSelector;

export { AppDispatchType, useAppDispatch, useAppSelector };
